import axios from "axios"
export function getAds(token) {
    return axios.get(process.env.REACT_APP_API_URL + '/getAdsDisplayed', {
        headers: {
            'Authorization': `${token}`
        }});
}